import { render } from "./areaDashboard.vue?vue&type=template&id=6656a8e7&scoped=true"
import script from "./areaDashboard.vue?vue&type=script&lang=js"
export * from "./areaDashboard.vue?vue&type=script&lang=js"

import "./areaDashboard.vue?vue&type=style&index=0&id=6656a8e7&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6656a8e7"]])

export default __exports__